// extracted by mini-css-extract-plugin
module.exports = {"joinButton":"_7EAv0LwCOT7aMyKkZMwS"};